import React from 'react';
import { IconButton } from '../../../../../components/IconButton';
import { OfferRequisitionFeed } from '../../../../../entities/ApplicationFeed';
import { Link } from '../../../../../components/Link';
import styles from './styles.module.scss';
import classNames from 'classnames';

interface PropTypes {
  entry: OfferRequisitionFeed;
}

export function ViewRequisitionButton(props: PropTypes) {
  return (
    <Link
      href={`/applicant_tracking/offer_requisitions/${props.entry.offerRequisitionId}`}
      classNames={classNames('d-block', styles['action-button'])}
    >
      <IconButton
        iconName='bi-file-medical'
        buttonText='View Requisition'
        color='borderless'
      />
    </Link>
  );
}
